import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideMatomo, withRouter, MatomoInitializerService } from 'ngx-matomo-client';
import * as Sentry from '@sentry/angular';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initializeMatomo } from './init/matomo-init.factory';
import { initializeSentry } from './init/sentry-init.factory';
import { initializeSlugger } from './init/slugger-init.factory';
import { ErrorPageComponent } from './pages/common/error-page/error-page.component';
import { LoaderComponent } from './pages/common/loader/loader.component';
import { ConfigService } from './services/config/config.service';
import { SlugManagerService } from './services/slug/slug-manager.service';
import { TranslocoRootModule } from './transloco-root.module';
import { Router } from '@angular/router';

@Injectable()
export class AppGlobalErrorhandler implements ErrorHandler {
  private readonly config = inject(ConfigService);

  handleError(_error: Error) {
    this.config
      .loadAppConfig()
      .then(() => {
        return true;
      })
      .catch((err) => console.error(err));
  }
}

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    KeycloakAngularModule,
    TranslocoRootModule,
    BrowserAnimationsModule,
    AppComponent,
    LoaderComponent,
    ErrorPageComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideMatomo(
      { mode: 'deferred' },
      withRouter()
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigService: ConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      },
      multi: true,
      deps: [ConfigService]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSlugger,
      multi: true,
      deps: [ConfigService, SlugManagerService, KeycloakService]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMatomo,
      multi: true,
      deps: [ConfigService, MatomoInitializerService]
    },
    {
      provide: ErrorHandler,
      useClass: AppGlobalErrorhandler
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSentry,
      deps: [ConfigService, Sentry.TraceService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
